import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";

export const sendMetriks = (target, arr) => {
	let params = !!arr ? arr : [];
	Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS[target], params);
};
